var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M486.3 49.1h-89.5v-24c0-13.9-11.2-25.1-25.1-25.1-13.8 0-25.1 11.2-25.1 25.1v24H165.4v-24c0-13.9-11.2-25.1-25.1-25.1s-25.1 11.2-25.1 25.1v24H25.7C11.8 49.1.6 60.3.6 74.2V487c0 13.9 11.2 25.1 25.1 25.1h460.5c13.9 0 25.1-11.2 25.1-25.1V74.2c.1-13.9-11.2-25.1-25-25.1zm-25.1 412.7H50.8V99.3h64.4v25.3c0 13.9 11.2 25.1 25.1 25.1s25.1-11.2 25.1-25.1V99.3h181.3v25.3c0 13.9 11.2 25.1 25.1 25.1 13.8 0 25.1-11.2 25.1-25.1V99.3h64.4z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1 209.3h36.4c8.1 0 14.6 6.5 14.6 14.6v36.4c0 8.1-6.5 14.6-14.6 14.6h-36.4c-8.1 0-14.6-6.5-14.6-14.6v-36.4c0-8.1 6.5-14.6 14.6-14.6zM237.8 209.3h36.4c8.1 0 14.6 6.5 14.6 14.6v36.4c0 8.1-6.5 14.6-14.6 14.6h-36.4c-8.1 0-14.6-6.5-14.6-14.6v-36.4c0-8.1 6.5-14.6 14.6-14.6zM353.5 209.3h36.4c8.1 0 14.6 6.5 14.6 14.6v36.4c0 8.1-6.5 14.6-14.6 14.6h-36.4c-8.1 0-14.6-6.5-14.6-14.6v-36.4c0-8.1 6.5-14.6 14.6-14.6zM122.1 325.1h36.4c8.1 0 14.6 6.5 14.6 14.6v36.4c0 8.1-6.5 14.6-14.6 14.6h-36.4c-8.1 0-14.6-6.5-14.6-14.6v-36.4c0-8 6.5-14.6 14.6-14.6zM237.8 325.1h36.4c8.1 0 14.6 6.5 14.6 14.6v36.4c0 8.1-6.5 14.6-14.6 14.6h-36.4c-8.1 0-14.6-6.5-14.6-14.6v-36.4c0-8 6.5-14.6 14.6-14.6zM353.5 325.1h36.4c8.1 0 14.6 6.5 14.6 14.6v36.4c0 8.1-6.5 14.6-14.6 14.6h-36.4c-8.1 0-14.6-6.5-14.6-14.6v-36.4c0-8 6.5-14.6 14.6-14.6z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/events-icon.b7e3b85eab62de7edb2f36a0ddf42af8.svg";
export { ForwardRef as ReactComponent };